import { Avatar } from '@chakra-ui/react';
import React, { ReactNode } from 'react';

import { CmFlex, CmText, CmTooltip } from '@/components/uiParts';
import { ommisionText } from '@/lib/util';
import { useManagerAccountMe } from '@/services/AuthEnterprise/hooks';

type Props = {
  alert?: ReactNode;
};

export const Header: React.FC<Props> = ({ alert }) => {
  const { managerAccountMe: me } = useManagerAccountMe();
  const name = me?.name ?? '';
  return (
    <CmFlex alignItems="center">
      {alert}
      <CmText
        align="right"
        fontWeight="bold"
        mr={2}
        minWidth="70px"
        maxWidth="130px"
      >
        <CmTooltip label={name}>{ommisionText(name, 4)}</CmTooltip>
      </CmText>
      {/*
       // @ts-ignore TS2590 */}
      <Avatar name={name} />
    </CmFlex>
  );
};
